import Logo from '../components/assets/Logo';
import SupportLink from '../components/SupportLink';
import Text from '../components/Text';

const UnderMaintenance = () => {
  return (
    <div className="h-screen overflow-hidden relative text-center">
      <div className="flex justify-center my-8 md:mt-[58px] md:mb-[168px]">
        <Logo />
      </div>
      <div className="flex w-full h-full flex-col items-center">
        <div className="flex w-full flex-col justify-center align-center relative">
          <div className="w-full pt-[252px] bg-[url('/ClosedDoorWithPlants.svg')] bg-top bg-no-repeat">
            <Text.H2 className="mt-11 mb-4 mx-5">We’ll be right back.</Text.H2>
            <Text.P className="text-tertiary-5 mx-5">
              We’re undergoing maintenance
              <br />
              If you need immediate help, please contact <SupportLink />
            </Text.P>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
